// A dismissible site notice along the top edge. Shown until `expires` or until
// the visitor closes it; closing is remembered per notice id.

export type Notice =
  id: string
  expires: string // ISO date, exclusive
  message: string

export showNotice := (notice: Notice): void =>
  { id, expires, message } := notice
  key := `notice-dismissed:${id}`

  return if Date.now() >= Date.parse(expires)
  try
    return if localStorage.getItem(key)

  element := document.createElement "aside"
  element.className = "site-notice"
  element.setAttribute "role", "status"

  text := document.createElement "span"
  text.textContent = message

  close := document.createElement "button"
  close.textContent = "✕"
  close.title = "Dismiss"
  close.onclick = ->
    element.remove()
    try
      localStorage.setItem key, "1"

  element.append text, close
  document.body.append element

// Publish URL corrupted every song from the HTTP API migration (2026-09-19)
// until the fix (1e41232, 2026-10-26).
export PUBLISH_FIX_NOTICE: Notice :=
  id: "publish-fix-2026-10-26"
  expires: "2026-11-09"
  message: "Fixed Oct 26: Publish URL links made between Sept 19 and Oct 26 open blank. Open your saved song and use Publish URL again to get a working link."
